import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
const defaultHosts = {
  qa: 'https://qa-membership-api.theknot.com',
  production: 'https://membership-api.theknot.com'
};

const invalidEnv = env => {
  /* eslint-disable no-console */
  console.error(`Specified 'env' value: ${_JSON$stringify(env)} is invalid. Please use 'qa' or 'production'`);
  /* Fallback to qa if ENV is invalid */

  return defaultHosts.qa;
};

const configureClient = _ref => {
  let {
    env = (() => {
      if (process.env.UNION_MEMBERSHIP_ENV) {
        if (process.env.UNION_MEMBERSHIP_ENV !== "qa" && process.env.UNION_MEMBERSHIP_ENV !== "production") {
          throw new Error(`Expected UNION_MEMBERSHIP_ENV to be 'qa' or 'production'.`);
        }

        console.warn('Using UNION_MEMBERSHIP_ENV could result in a misconfigured environment. It is best that you use UNION_DEPLOYMENT_ENV for all your Union services integrations.');
        return process.env.UNION_MEMBERSHIP_ENV;
      }

      if (process.env.UNION_DEPLOYMENT_ENV) {
        if (process.env.UNION_DEPLOYMENT_ENV !== "qa" && process.env.UNION_DEPLOYMENT_ENV !== "production") {
          throw new Error(`Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'.`);
        }

        return process.env.UNION_DEPLOYMENT_ENV;
      }

      if (true) {
        console.warn("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'. NODE_ENV fallback will be removed in a future version.");
        return process.env.NODE_ENV === 'production' ? 'production' : 'qa';
      }

      throw new Error("Expected UNION_DEPLOYMENT_ENV to be either 'qa' or 'production'.");
    })(),
    host = process.env.UNION_MEMBERSHIP_HOST || defaultHosts[env] || invalidEnv(env),
    apiKey = process.env.UNION_MEMBERSHIP_API_KEY,
    version = 'v1'
  } = _ref;
  return {
    host,
    apiKey,
    version
  };
};

export default configureClient;